import { apiGet, apiPost, apiPatch, apiDelete } from './api-client';
import type { CoachingAgent, CoachingAgentAdmin } from '@/types';

// ============================================
// Public Agent Operations
// ============================================

/**
 * Get all active agents for selection
 */
export async function getActiveAgents(): Promise<CoachingAgent[]> {
  const response = await apiGet<{ agents: CoachingAgent[] }>('/api/agents');
  return response.agents;
}

/**
 * Get specific agent details
 */
export async function getAgent(agentId: string): Promise<CoachingAgent> {
  const response = await apiGet<{ agent: CoachingAgent }>(`/api/agents/${agentId}`);
  return response.agent;
}

// ============================================
// Admin Agent Operations
// ============================================

/**
 * Get all agents including inactive (admin only)
 */
export async function getAllAgentsAdmin(): Promise<CoachingAgentAdmin[]> {
  const response = await apiGet<{ agents: CoachingAgentAdmin[] }>('/api/agents/admin/all');
  return response.agents;
}

/**
 * Create new agent (admin only)
 */
export async function createAgent(agent: {
  name: string;
  slug: string;
  systemPrompt: string;
  iconName?: string;
  category?: string;
  description?: string;
  sortOrder?: number;
}): Promise<void> {
  await apiPost('/api/agents', agent);
}

/**
 * Update agent (admin only)
 */
export async function updateAgent(
  agentId: string,
  updates: Partial<CoachingAgentAdmin>
): Promise<void> {
  await apiPatch(`/api/agents/${agentId}`, updates);
}

/**
 * Delete agent (admin only)
 */
export async function deleteAgent(agentId: string): Promise<void> {
  await apiDelete(`/api/agents/${agentId}`);
}
